var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userChallenges-container"},_vm._l((_vm.challenges),function(challenge){return _c('user-challenge',{key:challenge.id,attrs:{"challenge":challenge,"game":_vm.game}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }